import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';

interface Props {
  onClick: () => void;
  color?: ButtonProps['color'];
  text: string;
  href?: string;
}

const SubmitButton: React.FC<Props> = ({ onClick, color = 'primary', text, href = undefined }) => {
  return (
    <Button
      onClick={onClick}
      sx={{
        textTransform: 'initial',
      }}
      fullWidth
      color={color}
      href={href}
    >
      {text}
    </Button>
  );
};

export default React.memo(SubmitButton);
